<template>
  <router-view />
</template>

<script>
export default {
  name: 'Finance'
}
</script>
